import React from "react"
import { Tooltip, Typography } from "antd"
import { EditOutlined } from "@ant-design/icons"
import { getDisplayAddress } from "@/utils/addresses"
import { faCircleDot, faWarning } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Location } from "@/types/orders.types"
import { useTranslation } from "react-i18next"
import { useFlags } from "flagsmith/react"

interface DisplayCellSenderProps {
  sender?: Location
  withPhone?: boolean
  pickupErrors?: string[]
  isEditable?: boolean
}

const { Text } = Typography
const DisplayCellSender: React.FC<DisplayCellSenderProps> = ({
  pickupErrors,
  withPhone,
  sender,
  isEditable,
}) => {
  const { t } = useTranslation(["common"])
  const flags = useFlags(["show_address_inaccurate"])
  const hasError = pickupErrors && pickupErrors?.length > 0

  return (
    <div
      className={`flex flex-col text-ellipsis group ${
        isEditable || hasError ? "cursor-pointer" : ""
      }`}
    >
      <Tooltip
        placement="topLeft"
        title={
          hasError ? (
            <div>
              {pickupErrors?.map((error, index) => {
                return (
                  <p key={index} className="whitespace-pre-line">
                    {error}
                  </p>
                )
              })}
            </div>
          ) : undefined
        }
      >
        <div className="flex flex-row items-center text-ellipsis overflow-hidden whitespace-nowrap">
          <div className={`flex w-5 h-5 mr-2 rounded-md bg-kosmoLightGray`}>
            <FontAwesomeIcon
              className={`flex-shrink-0 h-3 mx-auto my-auto text-sm ${
                hasError ? "text-red-500" : "text-black"
              }`}
              icon={faCircleDot}
            />
          </div>
          <Text
            className="flex text-ellipsis overflow-hidden whitespace-nowrap text-black font-medium capitalize"
            ellipsis
          >
            {sender?.location?.alias || `${sender?.firstName} ${sender?.lastName}`}
            <EditOutlined className="ml-1 invisible group-hover:visible" hidden={!isEditable} />
          </Text>
        </div>
      </Tooltip>
      <div className="flex flex-shrink-0 gap-x-1 text-ellipsis whitespace-nowrap overflow-hidden">
        {flags.show_address_inaccurate.enabled && sender?.location?.isWarning && (
          <Tooltip title={t("errors.draftUpload.addressMayBeInaccurate")}>
            <p>
              <FontAwesomeIcon icon={faWarning} className="text-yellow-500" />
            </p>
          </Tooltip>
        )}
        <p className="flex-shrink-0 text-gray-500 text-ellipsis whitespace-nowrap overflow-hidden">
          {getDisplayAddress(sender?.location, true)}
        </p>
      </div>
      {withPhone && (
        <p className="flex-shrink-0 text-gray-500 text-ellipsis whitespace-nowrap overflow-hidden text-sm">
          {sender?.phone}
        </p>
      )}
    </div>
  )
}

export default DisplayCellSender
